import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function Cta() {
  return (
    <div className='home-cta'>
      <Container>
        <Row>
          <Col className='col-12 col-md-8 col-xl-5 home-cta-content d-grid align-content-center py-4'>
            <div className='d-grid gap-2-rem'>
              <div className='d-grid gap-2'>
                <h1 className='m-0 fs-48 fs-sm-25 fw-semibold' data-aos="fade-right">Eco-Friendly</h1>
                <p className='m-0 fs-md-14 fs-sm-14' data-aos="fade-right" data-aos-delay="150">Nexus Eco-Friendly Paper Cups are crafted from sustainably sourced materials and lined with biodegradable coatings, ensuring minimal environmental impact. Designed for convenience and sustainability, these cups are perfect for hot and cold beverages, offering a greener way to sip without compromising quality.</p>
              </div>
              <div className='d-flex' data-aos="fade-right" data-aos-delay="300">
                <Link to={"/about-us"} className='content-btn fw-semibold'>
                  Our Commitment
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Cta